import { apiSlice } from "../../app/api/apiSlice";

export const applicationApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getBrokerListByTitleBranch: builder.mutation({
			// query: (credentials) => ({
			// 	url: `api/v1/admin/parent_child/broker_title_search_modified?org_name=${credentials?.orgName}&title=${credentials?.title}&include_child=${credentials?.include_child}`,
			// 	method: "GET",
			// }),

			query: (credentials) => {
				const orgName = encodeURIComponent(credentials?.orgName ?? "");
				const title = encodeURIComponent(credentials?.title ?? "");
				const includeChild = encodeURIComponent(credentials?.include_child ?? "");
				return {
					url: `api/v1/admin/parent_child/broker_title_search_modified?org_name=${orgName}&title=${title}&include_child=${includeChild}`,
					method: "GET",
				};
			},
		}),
	}),
});

export const { useGetBrokerListByTitleBranchMutation } = applicationApiSlice;
